import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Wrench, History, DollarSign } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const BottomNav = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const navItems = [
    { to: '/', icon: Wrench, label: t('customerIntake') },
    { to: '/history', icon: History, label: t('customerHistory') },
    { to: '/daily-cash', icon: DollarSign, label: t('dailyCashRegister') },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 lg:hidden safe-area-bottom">
      <div className="flex justify-around items-center h-12 md:h-14">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.to ||
            (item.to === '/' && location.pathname === '/') ||
            (item.to === '/history' && location.pathname.startsWith('/history'));

          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive: navIsActive }) =>
                `flex flex-col items-center justify-center flex-1 h-full transition-colors px-1 ${
                  navIsActive || isActive
                    ? 'text-blue-600'
                    : 'text-gray-400 hover:text-gray-600'
                }`
              }
            >
              <Icon className="w-[18px] h-[18px] md:w-5 md:h-5 mb-0.5" />
              <span className="text-[10px] md:text-xs font-medium text-center leading-tight truncate max-w-full">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
